import { render, staticRenderFns } from "./UsersTableItem.vue?vue&type=template&id=f027128a&scoped=true"
import script from "./UsersTableItem.vue?vue&type=script&lang=js"
export * from "./UsersTableItem.vue?vue&type=script&lang=js"
import style0 from "./UsersTableItem.vue?vue&type=style&index=0&id=f027128a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f027128a",
  null
  
)

export default component.exports